// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"426b0b06","146":"0816d611"}[chunkId] + ".chunk.css";
};